<template>
  <b-navbar-nav>
    <b-nav-item
      v-if="permissions.isAdminAndAbove && permissions.isUsePurchase"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.purchaseOrderList"
      @click="onClickNavItem($appConfig.serviceID.purchase)"
    >
      {{ $t('受発注管理') }}
    </b-nav-item>
    <span v-if="permissions.isUseInventory" class="d-contents">
      <b-nav-item
        class="d-block d-lg-none"
        :href="$appConfig.ScreenUrl.ship"
        @click="onClickNavItem($appConfig.serviceID.inventory)"
      >
        {{ $t('在庫管理') }}
      </b-nav-item>
      <b-nav-item
        class="nav-item-sub"
        :class="setActivePageClass($appConfig.ScreenUrl.ship)"
        :href="$appConfig.ScreenUrl.ship"
      >
        {{ $t('出庫') }}
      </b-nav-item>
      <b-nav-item
        class="nav-item-sub"
        :class="setActivePageClass($appConfig.ScreenUrl.supply)"
        :href="$appConfig.ScreenUrl.supply"
      >
        {{ $t('手配 / 入庫') }}
      </b-nav-item>
      <b-nav-item
        class="nav-item-sub"
        :class="setActivePageClass($appConfig.ScreenUrl.lot)"
        :href="$appConfig.ScreenUrl.lot"
      >
        {{ $t('棚卸') }}
      </b-nav-item>
      <b-nav-item
        class="nav-item-sub"
        :class="setActivePageClass($appConfig.ScreenUrl.inventory)"
        :href="$appConfig.ScreenUrl.inventory"
      >
        {{ $t('在庫') }}
      </b-nav-item>
      <span v-if="permissions.isAdminAndAbove" class="d-contents">
        <b-nav-item
          class="nav-item-sub"
          :class="setActivePageClass($appConfig.ScreenUrl.inventoryAnalysis)"
          :href="$appConfig.ScreenUrl.inventoryAnalysis"
        >
          {{ $t('分析') }}
        </b-nav-item>
        <b-nav-item
          class="nav-item-sub"
          :class="
            setActivePageClass($appConfig.ScreenUrl.inventoryAnalysisHistory)
          "
          :href="$appConfig.ScreenUrl.inventoryAnalysisHistory"
        >
          {{ $t('履歴') }}
        </b-nav-item>
        <b-nav-item
          class="nav-item-sub"
          :class="setActivePageClass($appConfig.ScreenUrl.import)"
          :href="$appConfig.ScreenUrl.import"
        >
          {{ $t('データ一覧') }}
        </b-nav-item>
      </span>
    </span>
    <b-nav-item
      v-if="permissions.isUseSmallLot"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.scheduleOrder"
      @click="onClickNavItem($appConfig.serviceID.smallLot)"
    >
      {{ $t('工程管理') }}
    </b-nav-item>
    <b-nav-item
      v-if="permissions.isMasterAdminAndAbove"
      class="d-block d-lg-none"
      :href="$appConfig.ScreenUrl.settingMenu"
      @click="onClickNavItem($appConfig.serviceID.base)"
    >
      {{ $t('各種設定') }}
    </b-nav-item>
  </b-navbar-nav>
</template>

<script>
export default {
  props: {
    /** サービスの使用権限を取得する関数群 */
    permissions: {
      type: Object,
      required: true,
    },
    /**
     * 引数に指定されたページが表示されているか。
     * 真の場合、文字を黒色太字とし、罫線を引くCSSクラス名を返却する。
     */
    setActivePageClass: {
      type: Function,
      required: true,
    },
  },
  methods: {
    /** ナビゲーションアイテムをクリック時の処理 */
    onClickNavItem(serviceID) {
      this.$emit('onClickNavItem', serviceID)
    },
  },
}
</script>

<style lang="scss" scoped>
.d-contents {
  display: contents;
}
</style>
